import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class QueryParamService {
  constructor(private router: Router) {}

  addQueryParam(param: string, value: string) {
    this.router.navigate([], {
      queryParams: { [param]: value },
      queryParamsHandling: 'merge',
    });
  }

  removeQueryParam(param: string) {
    this.router.navigate([], {
      queryParams: { [param]: null },
      queryParamsHandling: 'merge',
    });
  }
}
